import {
    Table,
    TableRow,
    TableCell,
    Paragraph,
    TextRun,
    WidthType,
    HeightRule
} from "docx";

export function buildMaturityTable(record) {

    if (!record) {
        return new Paragraph(""); // fallback
    }

    const firstKeys = [
        'Timestamp', 'Status', 'investmentAmount', 'interestRate',
        'Term', 'maturityDate', 'earnedInterest',
        'contractCode', 'Value', 'Payment'
    ];

    const keys = [
        'oeTimestamp', 'newTermStatus', 'newAmount', 'newRate',
        'newTerm', 'newMaturity', 'newROI',
        'newRepaymentOptions', 'newValue', 'newPayment'
    ];

    const headings = [
        "NOTE ID", "STATUS", "AMOUNT", "RATE", "TERM",
        "MATURITY", "ROI", "OPTIONS",
        "VALUE", "MATURITY PAYMENT"
    ];

    // -----------------------------
    // Build header row
    // -----------------------------
    const headerRow = new TableRow({
        children: headings.map(h =>
            new TableCell({
                children: [
                    new Paragraph({
                        children: [
                            new TextRun({ text: h, bold: true })
                        ]
                    })
                ],
                width: { size: 10, type: WidthType.PERCENTAGE }
            })
        ),
        height: { value: 400, rule: HeightRule.EXACT }
    });

    // -----------------------------
    // Build first (original) row
    // -----------------------------
    const firstRow = new TableRow({
        children: firstKeys.map(key =>
            new TableCell({
                children: [
                    new Paragraph(
                        Array.isArray(record[key])
                            ? String(record[key][0] || "")
                            : String(record[key] || "")
                    )
                ],
                width: { size: 10, type: WidthType.PERCENTAGE }
            })
        ),
        height: { value: 400, rule: HeightRule.EXACT }
    });

    // -----------------------------
    // Build renewal rows
    // -----------------------------
    const renewalRows = [];
    const rowCount = record.newMaturity?.length || 0;

    for (let i = 0; i < rowCount; i++) {

        // If Pending, still include row (matches your HTML behavior)
        const row = new TableRow({
            children: keys.map(key =>
                new TableCell({
                    children: [
                        new Paragraph(String(record[key]?.[i] || ""))
                    ],
                    width: { size: 10, type: WidthType.PERCENTAGE }
                })
            ),
            height: { value: 400, rule: HeightRule.EXACT }
        });

        renewalRows.push(row);
    }

    // -----------------------------
    // Build final DOCX table
    // -----------------------------
    return new Table({
        width: { size: 100, type: WidthType.PERCENTAGE },
        rows: [
            headerRow,
            firstRow,
            ...renewalRows
        ]
    });
}
